export default "__VITE_ASSET__3a7803c4__"